import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../../api/client";
import SubLayout from "../SubLayout/SubLayout";
import { IconScissors, IconWhatsApp } from "../icons/Icons";

const WHATSAPP_URL = "https://wa.me/640997403";

function Servicios() {
    const [services, setServices] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        apiGet("/work_group/1/services", { context: "pagina_servicios" })
            .then((res) => setServices(res.data.services || []))
            .catch((err) => setError(err));
    }, []);

    return (
        <SubLayout
            icon={IconScissors}
            title="Servicios y Precios"
            intro="Descubre todos nuestros servicios y cuidado personal con la atención y precisión que nos caracteriza."
            wide
        >
            {/* Special — fuera de horario */}
            <div className="svc-special">
                <span className="svc-ico" style={{ border: "none", width: 40 }}>
                    <IconScissors />
                </span>
                <div className="svc-info">
                    <h3>Corte fuera de horario</h3>
                    <p className="svc-price">Consultar disponibilidad por WhatsApp</p>
                </div>
                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pill-btn pill-btn--ghost"
                    aria-label="Consultar por WhatsApp"
                >
                    <IconWhatsApp />
                </a>
            </div>

            {error && (
                <p className="subpage-intro" style={{ marginTop: 16 }}>
                    No se pudieron cargar los servicios. Inténtalo más tarde.
                </p>
            )}

            <div className="svc-list">
                {services.map((service, i) => {
                    return (
                        <div key={i} className="svc-row">
                            <span className="svc-ico">
                                <IconScissors />
                            </span>
                            <div className="svc-info">
                                <h3>{service.name}</h3>
                                <p className="svc-price">
                                    {service.price}€
                                    {service.duration ? ` / ${service.duration}min` : ""}
                                </p>
                            </div>
                            <Link to="/reservas" className="pill-btn">
                                Reserva
                            </Link>
                        </div>
                    );
                })}
            </div>
        </SubLayout>
    );
}

export default Servicios;
